import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CookieModule } from 'ngx-cookie';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Angulartics2Module } from 'angulartics2';

import { ErrorPageModule } from '@reg/error-page/error-page.module';
import { AppComponent } from '@reg/app.component';
import { AppRoutingModule } from '@reg/app-routing.module';
import { HeaderModule } from '@reg/header/header.module';
import { SharedModule } from '@reg/shared/shared.module';
import { ServicesModule } from '@reg/shared/services.module';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        CookieModule.withOptions(),
        ServicesModule,
        SharedModule,
        HeaderModule,
        AppRoutingModule, // Must be after other modules that have routes defined for wildcard (**) route
        ErrorPageModule,
        Angulartics2Module.forRoot(),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
